export interface OfflineModulePolicy {
  enabled: boolean;
  readCache: boolean;
  writeQueue: boolean;
  maxStaleMinutes: number;
  precacheRoutes: boolean;
}

const disabledPolicy = (): OfflineModulePolicy => ({
  enabled: false,
  readCache: false,
  writeQueue: false,
  maxStaleMinutes: 0,
  precacheRoutes: false,
});

/** Per-module offline policy registry — only `service` is enabled in v1. */
export const OFFLINE_MODULE_POLICY: Record<string, OfflineModulePolicy> = {
  adjustment: disabledPolicy(),
  'asset-management': disabledPolicy(),
  auth: disabledPolicy(),
  'budget-accounts-management': disabledPolicy(),
  'cue-system-setup': disabledPolicy(),
  customer: disabledPolicy(),
  delivery: disabledPolicy(),
  'delivery-planning': disabledPolicy(),
  'gas-pricing': disabledPolicy(),
  general: disabledPolicy(),
  'inspection-management': disabledPolicy(),
  'inventory-management': disabledPolicy(),
  invoicing: disabledPolicy(),
  lead: disabledPolicy(),
  modules: disabledPolicy(),
  'order-management': disabledPolicy(),
  product: disabledPolicy(),
  'product-management': disabledPolicy(),
  profile: disabledPolicy(),
  service: {
    enabled: true,
    readCache: true,
    writeQueue: true,
    maxStaleMinutes: 0,
    precacheRoutes: true,
  },
  statements: disabledPolicy(),
  workbench: disabledPolicy(),
};

export const OFFLINE_ENABLED_MODULES = Object.entries(OFFLINE_MODULE_POLICY)
  .filter(([, policy]) => policy.enabled)
  .map(([key]) => key);
